/* eslint import/prefer-default-export: 0 */
import jQuery from 'jquery';
import { appendRating } from './appendRating';

export const fetchRating = () => {
    const $ratingSpans = jQuery('.js-ratingSpan');
    const $ratingCells = jQuery('.js-ratingCell');

    const ratingIds = jQuery.makeArray($ratingSpans).map(el => el.dataset.ratingId);

    const handleData = responce =>
        appendRating(responce.data, $ratingSpans, $ratingCells, ratingIds);

    jQuery.post('ugc/rating', { ratingIds }).always(handleData);
};



// WEBPACK FOOTER //
// ./lib/js/modules/myRating/fetchRating.js